export var AuthConstants;
(function (AuthConstants) {
    AuthConstants["ACCESS_TOKEN"] = "ACCESS_TOKEN";
    AuthConstants["TERMO_CONFIDENCIALIDADE"] = "TERMO_CONFIDENCIALIDADE";
    AuthConstants["USER_NAME"] = "USER_NAME";
    AuthConstants["USER_CPF"] = "USER_CPF";
    AuthConstants["FIRST_ACCEPT"] = "FIRST_ACCEPT";
    AuthConstants["FIRST_VERSION_TERM"] = "FIRST_VERSION_TERM";
    AuthConstants["MODO_ATENDIMENTO"] = "MODO_ATENDIMENTO";
    AuthConstants["REQUERIMENTO_CACHE"] = "REQUERIMENTO_CACHE";
    AuthConstants["PARCELA_IMOVEL_CACHE"] = "PARCELA_IMOVEL_CACHE";
    AuthConstants["PARCELA_IMOVEL_CONCEDIDO_CACHE"] = "PARCELA_IMOVEL_CONCEDIDO_CACHE";
    AuthConstants["DADOS_CARTOGRAFICOS_LIMITROFES_CACHE"] = "DADOS_CARTOGRAFICOS_LIMITROFES_CACHE";
    AuthConstants["INDEX_ANEXOS_VIEWED"] = "INDEX_ANEXOS_VIEWED";
    AuthConstants["ENVIAR_PECAS_TEC_CACHE"] = "ENVIAR_PECAS_TEC_CACHE";
    AuthConstants["MT_CIDADAO_TOKEN"] = "kcToken";
})(AuthConstants || (AuthConstants = {}));
